import { MutableRefObject } from 'react';
import { WebsocketAction } from '@interfaces/webSocketConnectionInfo';
import { log } from './Debug';

export function teleportToRegion(
  regionName: string,
  sendJSONMessageToWebSocketRef: MutableRefObject<(message: any) => void>,
) {
  log('teleport region', regionName);

  const wsMessage = {
    action: WebsocketAction.MytaverseAction,
    tag: 'MytaEvent.Action.Teleport.ToRegion',
    data: regionName,
  };
  log('sendJSONMessageToWebSocket', wsMessage);

  sendJSONMessageToWebSocketRef.current(wsMessage);
}
